import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { LINKS } from "../lib/config";
import { useEffect, useRef } from "react";

export default function CalendlyModal({ open, onOpenChange }) {
    const widgetRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        const url = `${LINKS.calendly}?hide_gdpr_banner=1&primary_color=e21b5a`;

        const initWidget = () => {
            if (window.Calendly && widgetRef.current) {
                widgetRef.current.innerHTML = "";
                window.Calendly.initInlineWidget({
                    url,
                    parentElement: widgetRef.current,
                });
            }
        };

        if (window.Calendly) {
            // Small delay to ensure the modal DOM is mounted
            const t = setTimeout(initWidget, 100);
            return () => clearTimeout(t);
        }

        const existing = document.querySelector('script[src*="calendly.com/assets/external/widget.js"]');
        if (existing) {
            existing.addEventListener("load", initWidget, { once: true });
            return;
        }
        const s = document.createElement("script");
        s.src = "https://assets.calendly.com/assets/external/widget.js";
        s.async = true;
        s.onload = () => setTimeout(initWidget, 100);
        document.body.appendChild(s);
    }, [open]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                data-testid="calendly-modal"
                className="max-w-3xl h-[85vh] p-0 overflow-hidden border-0 bg-white"
            >
                <DialogHeader className="px-6 pt-6 pb-3 border-b border-black/10">
                    <DialogTitle className="font-serif text-2xl md:text-3xl text-ink">
                        Prenota una consulenza gratuita
                    </DialogTitle>
                    <p className="text-sm text-ink-muted font-sans">
                        Scegli il giorno e l&apos;orario più comodo per te.
                    </p>
                </DialogHeader>
                <div
                    ref={widgetRef}
                    className="h-[calc(85vh-90px)] w-full"
                    style={{ minWidth: "320px" }}
                />
            </DialogContent>
        </Dialog>
    );
}
